import {useField} from 'formik'
import React, {useEffect, useState} from 'react'
import {fetch} from 'yetch'
import {Dropdown, DropdownItem} from '../dropdown'

type School = [string, string]

export const PickSchool = ({
	school_location_placeholder,
	school_location_label,
	school_name_label
}) => {
	const [zipcodes, setZipcodes] = useState<Array<string>>([])
	const [schools, setSchools] = useState({})
	useEffect(() => {
		fetch(`/api/schools/zipcodes`)
			.then(res => res.json())
			.then(codes => codes.map(String))
			.then(setZipcodes)
	}, [])
	const [, {value: zip}] = useField('school_location')
	const [field, meta, helpers] = useField('school_name')
	const zipCode = zip && zip.length === 4 ? zip : ''
	useEffect(() => {
		fetch(`/api/schools?zip=${zipCode}`)
			.then(res => res.json())
			.then(setSchools)
	}, [zipCode])
	return (
		<>
			<div class="field">
				<div class="field-container">
					<label htmlFor="school_name" class="mod-row field-label">
						{school_location_label}
					</label>
					<Dropdown<string>
						autocomplete
						keepQuery
						name="school_location"
						placeholder={school_location_placeholder}
						itemToString={v => v}
						itemToKey={v => v}
					>
						{query =>
							query &&
							query.length > 1 &&
							zipcodes
								.filter(code => code.startsWith(query))
								.map((code, index) => (
									<DropdownItem item={code} index={index}>
										{code}
									</DropdownItem>
								))
						}
					</Dropdown>
				</div>
			</div>
			<div class="field">
				<div class="field-container">
					<label htmlFor="school_name" class="mod-row field-label">
						{school_name_label}
					</label>
					<Dropdown
						autocomplete
						keepQuery
						name="school_name"
						placeholder=""
						itemToString={school => school && school[1]}
						itemToKey={school => school && school[0]}
					>
						{query => {
							if (!query || query.length < 3) return null
							return Object.entries(schools)
								.filter((school: School) =>
									school[1].toLowerCase().includes(query.toLowerCase())
								)
								.map((school, index) => (
									<DropdownItem item={school} index={index}>
										{school[1]}
									</DropdownItem>
								))
						}}
					</Dropdown>
				</div>
			</div>
		</>
	)
}
